import { render, staticRenderFns } from "./GlobalGeofenceAddEditView.vue?vue&type=template&id=5aa96c4e&scoped=true&"
import script from "./GlobalGeofenceAddEditView.vue?vue&type=script&lang=js&"
export * from "./GlobalGeofenceAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./GlobalGeofenceAddEditView.vue?vue&type=style&index=0&id=5aa96c4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa96c4e",
  null
  
)

export default component.exports